// import { useState } from "react";
// import { toast } from "react-toastify";
// import { deleteOrganizationApi } from "../../apis/organizationApi";

// export const useDeleteOrganization = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const deleteOrganization = async (orgId) => {
//     setLoading(true);
//     setError(null);

//     const toastId = toast.loading("Deleting organization...");

//     try {
//       await deleteOrganizationApi(orgId);

//       toast.update(toastId, {
//         render: "Organization deleted successfully",
//         type: "success",
//         isLoading: false,
//         autoClose: 3000,
//       });
//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.data ||
//         err.data ||
//         "Failed to delete organization.";

//       toast.update(toastId, {
//         render: errorMessage,
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });

//       setError(errorMessage);
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   };

//   return { deleteOrganization, loading, error };
// };

import { useState } from "react";
import { toast } from "react-toastify";
import { deleteOrganizationApi } from "../../apis/organizationApi";

export const useDeleteOrganization = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
    const res = err.response?.data;

    return {
      title: res?.message || "Delete Failed",
      issue:
        res?.data ||
        err.message ||
        "Failed to delete organization.",
    };
  };

  const deleteOrganization = async (orgId) => {
    setLoading(true);
    setError(null);

    const toastId = toast.loading("Deleting organization...");

    try {
      await deleteOrganizationApi(orgId);

      toast.update(toastId, {
        render: (
          <div>
            <strong>Organization Deleted</strong>
            <div>The organization was removed successfully.</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });

      setError({ title, issue });
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { deleteOrganization, loading, error };
};